import Fuse from "fuse.js"
import { useMemo } from "react"

export default function useFuseSearch(data, keys, term) {
  const serializedKeys = JSON.stringify(keys)

  return useMemo(() => {
    if (!term || !term.trim()) return data
    if (!data || data.length === 0) return data

    const fuse = new Fuse(data, {
      keys,
      threshold: 0.3,
      ignoreLocation: true,
      minMatchCharLength: 1,
    })

    return fuse.search(term).map((result) => result.item)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, serializedKeys, term])
}
